import React, { useState } from "react";
import "./Login.scss";
import { useNavigate } from "react-router-dom";
import newRequest from "../../utils/newRequest";
import { toast } from "react-toastify";

const Login = () => {
  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await newRequest.post("auth/login", user);
      localStorage.setItem("currentUser", JSON.stringify(res.data));
      navigate("/");
      toast.success(`Welcome ${user?.username}`);
    } catch (err) {
      toast.error(err?.response.data.message || "An error occurred");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name) {
      setUser((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <div className="login">
      <form onSubmit={handleSubmit}>
        <h1>Sign in</h1>
        <label htmlFor="">Username*</label>
        <input
          type="text"
          name="username"
          placeholder="Username"
          onChange={handleChange}
          required
        />
        <label htmlFor="">Password*</label>
        <input
          name="password"
          type="password"
          placeholder="Password"
          onChange={handleChange}
          required
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;
